import { CommonModule } from '@angular/common';
import { Component, ChangeDetectorRef } from '@angular/core';
import { AppSwal } from '../../Services/alertService';
import { ApiCallService } from '../../Services/ApiCallService';
import { Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';

export interface EnquiryForm {
  Name: string;
  Email: string;
  Phone: string;
  Location: string;
  CityID : number | null;
  Interest: string;
  Message: string;
  // InterestedIn?: string;
  consent: boolean;
}
export interface Blog {
  ID: number;
  Title: string;
  Description: string;
  EventDate: string;
  Tags: string;
  BannerImage: string;
}

@Component({
  selector: 'app-bookconsultation',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule],
  templateUrl: './bookconsultation.html',
  styleUrl: './bookconsultation.css',
})
export class Bookconsultation {
  constructor(
    private api: ApiCallService,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) { }

  enquiryForm: EnquiryForm = {
    Name: '',
    Email: '',
    Phone: '',
    Location: '',
    CityID: null,
    Interest: '',
    Message: '',
    consent: false,
    // InterestedIn: ''
  };
  cities = [
    { CityID: 1, CityName: 'Mumbai' },
    { CityID: 2, CityName: 'Kolkata' },
  ];

  validateEnquiryForm(): boolean {
    // Name validation
    if (!this.enquiryForm.Name || this.enquiryForm.Name.trim().length < 2) {
      AppSwal.fire('Empty Field', 'Name is required and must be at least 2 characters', 'info');
      console.error('Name is required and must be at least 2 characters');
      return false;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!this.enquiryForm.Email || !emailRegex.test(this.enquiryForm.Email)) {
      AppSwal.fire('Empty Field', 'A valid email is required', 'info');
      console.error('Valid email is required');
      return false;
    }

    // Phone validation
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!this.enquiryForm.Phone || !phoneRegex.test(this.enquiryForm.Phone)) {
      AppSwal.fire('Phone', 'A valid 10-digit phone number is required', 'info');
      console.error('Valid 10-digit phone number is required');
      return false;
    }

    // Location validation
  if (!this.enquiryForm.CityID) {
      AppSwal.fire('Empty Field', 'City is required', 'info');
      console.error('City is required');
      return false;
    }

    // Interest validation
    if (!this.enquiryForm.Interest || this.enquiryForm.Interest.trim().length === 0) {
      AppSwal.fire('Empty Field', 'Interest selection is required', 'info');
      console.error('Interest selection is required');
      return false;
    }

    // Message validation
    // if (!this.enquiryForm.Message || this.enquiryForm.Message.trim().length < 10) {
    //   AppSwal.fire('Empty Field', 'Message must be at least 10 characters', 'info');
    //   console.error('Message must be at least 10 characters');
    //   return false;
    // }

    // consent validation
    if (!this.enquiryForm.consent) {
      AppSwal.fire('Empty Field', 'consent selection is required', 'info');
      console.error('consent selection is required');
      return false;
    }

    return true;
  }

  submitEnquiryForm(): void {
    this.cdr.detectChanges();
    // STEP 1: Client-side validation
    if (!this.validateEnquiryForm()) {
      return;
    }
    const selectedCity = this.cities.find((c) => c.CityID === this.enquiryForm.CityID);
    this.enquiryForm.Location = selectedCity ? selectedCity.CityName : '';

    // STEP 2: Prepare payloads (single source of truth)
    const otpPayload = {
      clientEmail: this.enquiryForm.Email,
    }; 

    const mailPayload = {
      Name: this.enquiryForm.Name,
      Email: this.enquiryForm.Email,
      MobileNo: this.enquiryForm.Phone,
      City: this.enquiryForm.Location,
      Interest: this.enquiryForm.Interest,
      Message: this.enquiryForm.Message,
      //title: 'RedMonk Wellness',
    };


    // Prepare lead registration payload
    // const leadPayload = {
    //   LeadName: this.enquiryForm.Name,
    //   LeadEmail: this.enquiryForm.Email,
    //   Query: this.enquiryForm.Message,
    //   Gender: '',
    //   Address: this.enquiryForm.Location,
    //   City: this.enquiryForm.Location,
    //   ContactInfo: this.enquiryForm.Phone,
    //   Source: 'Website',
    //   FormType: this.enquiryForm.Interest,
    //   CreatedBy: 1,
    //   Age: 0,
    //   CreatedByRole: '',
    //   AssignedToID: 0,
    //   AssignedToRole: '',
    //   FormConsent: this.enquiryForm.consent,
    // };

    console.log(this.enquiryForm);
    console.log('it is working till now before send otp');

    // STEP 3: Show loader before sending OTP
    AppSwal.fire({
      title: 'Please wait...',
      text: 'Sending Verification Code to your email...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => AppSwal.showLoading(),
    });

    // STEP 4: Send OTP
    this.api.postData('User', 'SendEmailOtp', otpPayload).subscribe({
      next: (res: any) => {
        AppSwal.close(); // Close loader after API response

        if (!res?.success) {
          AppSwal.fire('Failed', 'Unable to send Verification Code. Please try again.', 'error');
          return;
        }

        // STEP 5: OTP input popup
        AppSwal.fire({
          title: 'Verification Code',
          text: 'Please enter the Verification Code sent to your email',
          input: 'text',
          inputPlaceholder: 'Enter 6-digit Verification Code',
          inputAttributes: {
            maxlength: '6',
            inputmode: 'numeric',
            autocomplete: 'one-time-code',
            autocapitalize: 'off',
            autocorrect: 'off',
          },
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-secondary',
          },
          buttonsStyling: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: true,
          confirmButtonText: 'Verify Code',
          cancelButtonText: 'Cancel',
          focusConfirm: false,
          preConfirm: (otp) => {
            if (!otp) {
              AppSwal.showValidationMessage('Verification Code is required');
              return false;
            }
            if (!/^[0-9]{6}$/.test(otp)) {
              AppSwal.showValidationMessage('Verification Code must be a 6-digit number');
              return false;
            }
            return otp;
          },
        }).then((result) => {
          if (!result.isConfirmed) return;

          const verifyPayload = {
            otp: result.value,
            email: this.enquiryForm.Email,
          };

          // STEP 6: Verify OTP (loader)
          AppSwal.fire({
            title: 'Verifying',
            text: 'Please wait...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => AppSwal.showLoading(),
          });

          this.api.postData('User', 'VerifyOtp', verifyPayload).subscribe({
            next: (verifyRes: any) => {
              AppSwal.close();

              if (!verifyRes?.success) {
                AppSwal.fire(
                  'Invalid Verification Code',
                  'The Verification Code you entered is incorrect.',
                  'error',
                );
                return;
              }

              // STEP 7: OTP verified successfully - Insert lead and send email simultaneously
              // Show single processing message
              AppSwal.fire({
                title: 'Processing',
                text: 'Submitting your enquiry...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => AppSwal.showLoading(),
              });

              // commenting the register API call to avoid insert lead in CRM 
              // Call both APIs simultaneously
              // const leadRegistration = this.api
              //   .postData('UserRoles', 'RegisterLeads', leadPayload)
              //   .toPromise();
              // const sendEmail = this.apiF
              //   .postData('Notification', 'SendMail', mailPayload)
              //   .toPromise();
              const sendCredentials = this.api
                .postData('User', 'InsertEnquiryDetails', mailPayload)
                .subscribe({
                  next: (credRes: any) => {
                    AppSwal.close();

                    if (credRes?.success) {
                      AppSwal.fire(
                        'Success',
                        'Your enquiry has been submitted successfully.',
                        'success'
                      ).then(() => {
                        this.router.navigateByUrl('/Thankyou');
                      });
                    } else {
                      AppSwal.fire(
                        'Failed',
                        credRes?.message || 'Unable to submit enquiry.',
                        'error'
                      );
                    }
                  },
                  error: () => {
                    AppSwal.close();
                    AppSwal.fire(
                      'Error',
                      'Something went wrong while submitting enquiry.',
                      'error'
                    );
                  }
                });
            },
            error: () => {
              AppSwal.close();
              AppSwal.fire(
                'Error',
                'Verification Code verification failed. Please try again.',
                'error',
              );
            },
          });
        });
      },
      error: () => {
        AppSwal.close();
        AppSwal.fire(
          'Error',
          'Unable to initiate Verification Code verification. Please try again.',
          'error',
        );
      },
    });
  }
}
